export default {
    props: {
        role: String,
    },
    data() {
        return {}
    },
    computed: {
        isCarrierManager() {
            return this.role === 'carrier_manager'
        },
        isClient() {
            return this.role === 'client'
        },
        isCaregiver() {
            return this.role === 'caregiver'
        },
        isOfficeUser() {
            return this.role === 'office_user'
        },
        isAdmin() {
            return this.role === 'admin'
        },
        isHighLevel() {
            return this.isAdmin || this.isOfficeUser
        },
        isHighLevelOrManager() {
            return this.isAdmin || this.isOfficeUser || this.isCarrierManager
        },
        isHighLevelClaimant() {
            return this.isProvider || this.isOfficeUser || this.isClaimant
        },
        isClaimant() {
            return this.claimantSingular === "claimants"
        },
        isProvider() {
            return this.providerSingular === "provider"
        },
        controller() {
            if (this.role === 'caregiver') {
                return 'caregiver'
            }
            if (this.role === 'client') {
                return 'client'
            }
            
            return this.role === 'carrier_manager' ? 'carriermanager' : 'business'
        },
        claimantModel() {
            return this.role === 'carrier_manager' ? 'claimants' : 'clients'
        },
        claimantSingular() {
            return this.role === 'carrier_manager' ? 'claimant' : 'client'
        },
        claimantUrlPrefix() {
            return `/${this.controller}/${this.claimantModel}`
        },
        providerModel() {
            return this.role === 'carrier_manager' ? 'providers' : 'caregivers'
        },
        providerSingular() {
            return this.role === 'carrier_manager' ? 'provider' : 'caregiver'
        },
        providerUrlPrefix() {
            return `/${this.controller}/${this.providerModel}`
        },
        knowledgePath() {
            return this.role === 'carrier_manager' ? 'knowledgecenter' : 'knowledge-manager'
        },
        userRegisterPath() {
            return `/users/register`
        }
    },
    methods: {
        mapRole(role) {
            switch (role) {
                case 'caregiver':
                    return 'Provider'
                case 'client':
                    return 'Claimant'
                case 'carrier_manager':
                    return 'Carrier Manager'
                default:
                    return role
            }
        },
        mapRoleToController(role) {
            switch (role) {
                case 'caregiver':
                    return this.providerModel
                case 'client':
                    return this.claimantModel
                default:
                    return role
            }
        },
    },
}
